module.exports = "/_next/static/images/ny-3-87fe1014784c5dba186a71015caaadaa.jpg";